export default "__VITE_ASSET__f84b1bac__"